import React from 'react';
import { usePortalShortcutMap } from './portalShortcutContext';
import { formatPortalShortcutAria, formatPortalShortcutHint, type PortalShortcutId } from './portalShortcuts';

/** Dezenter Kürzel-Hinweis am bestehenden Knopf. Kein Overlay. */
export const PortalShortcutHint: React.FC<{ id: PortalShortcutId; className?: string }> = ({
  id,
  className = '',
}) => {
  const map = usePortalShortcutMap();
  const aria = formatPortalShortcutAria(map[id]);
  return (
    <kbd
      className={`shrink-0 rounded border border-white/[0.1] px-1 py-0 text-[9px] font-medium leading-4 text-slate-500 ${className}`}
      title={aria}
    >
      {formatPortalShortcutHint(map[id])}
    </kbd>
  );
};
